//const url = { apiUrl: 'http://localhost:56881' };
const url = { apiUrl: 'https://www.birsala.com/api' };
const config = url;

export default {
  ...config
};
